<template>
    <header id="header__main">
        <div class="header__container" :class="{ onTop: !headerTopShow }">
            <section
                class="header__top"
                :class="{ shadox__effect: !getIsThisMainPage }"
            >
                <div
                    class="header_container d-flex justify-content-between align-items-center row"
                >
                    <div
                        class="catalog_box d-flex  align-items-center catalog__box__first col-xl-3 "
                        v-if="window.innerWidth > 768"
                        :key="'catalog__box__first'"
                    >
                        <div class="logo__box">
                            <router-link :to="{ name: 'home' }">
                                <svg width="100" height="40" viewBox="0 0 686 217" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M194.869 112.157C116.512 116.252 112.797 169.036 112.797 180.91C112.797 192.754 109.268 192.754 107.221 192.218C105.204 191.652 100.573 188.503 73.3324 165.357C46.9405 142.903 27.5394 111.248 26.3412 109.297C67.2808 160.756 107.046 180.814 107.046 180.814C109.28 88.2824 0.328613 75.2219 0.328613 75.2219C-6.88505 200.534 107.058 202.581 107.058 202.581C201.547 205.345 194.869 112.157 194.869 112.157ZM117.048 190.105C117.048 190.105 167.532 157.854 178.81 135.243C177.521 138.14 156.103 184.595 117.048 190.105Z" fill="#6C9672"/>
                                    <path d="M182.639 101.331C182.639 101.331 139.291 114.945 124.286 125.507C124.286 125.507 159.3 86.3254 163.744 68.2612C163.744 68.2612 126.495 97.718 117.054 112.169C117.054 112.169 129.566 67.7072 128.452 39.6414C128.452 39.6414 109.003 83.8266 105.107 107.726C105.107 107.726 90.9329 59.0966 83.1532 41.8693C83.1532 41.8693 80.9313 81.3277 92.6009 109.117C92.6009 109.117 66.2029 79.1058 28.6895 73.548C41.0755 36.4741 74.9521 12.4245 110.111 14.0804C137.972 15.3931 165.876 32.8071 177.635 59.9336C185.066 77.0585 183.892 93.0634 182.639 101.331Z" fill="#E5BD89"/>
                                    <path d="M297.414 135.244C297.414 135.244 317.694 131.053 317.411 111.055C317.188 95.4961 307.897 89.3543 295.427 86.0786C289.255 84.4709 282.89 83.8085 276.531 83.8085H237.103V193.85H285.732C285.732 193.85 316.598 193.314 321.572 173.57C326.575 153.856 321.036 144.408 297.414 135.244ZM252.096 91.0884H283.402C294.674 91.0884 303.808 100.223 303.808 111.465C303.808 117.101 301.538 122.207 297.823 125.886C294.138 129.571 289.038 131.841 283.396 131.841H252.09V91.0884H252.096ZM298.865 180.591C294.427 184.999 288.315 187.738 281.577 187.738H252.096V138.826H281.577C295.089 138.826 306.018 149.785 306.018 163.297C306.012 170.041 303.272 176.153 298.865 180.591Z" fill="#6C9672"/>
                                    <path d="M359.886 83.8145V161.316C359.886 177.225 372.784 190.117 388.686 190.117C404.595 190.117 417.487 177.219 417.487 161.316V83.8145H428.855V154.301C428.855 177.532 410.02 196.367 386.79 196.367C363.559 196.367 344.724 177.532 344.724 154.301V83.8145H359.886Z" fill="#6C9672"/>
                                    <path d="M469.65 83.8145V161.316C469.65 177.225 482.548 190.117 498.451 190.117C514.359 190.117 527.251 177.219 527.251 161.316V83.8145H538.62V154.301C538.62 177.532 519.785 196.367 496.554 196.367C473.323 196.367 454.488 177.532 454.488 154.301V83.8145H469.65Z" fill="#6C9672"/>
                                    <path d="M570.292 193.314L574.736 109.671L616.977 185.251H622.534L661.993 109.671L669.772 193.314H685.338L675.607 85.7715H665.606L625.033 166.91L581.131 85.7715H570.292L561.122 193.314H570.292Z" fill="#6C9672"/>
                                </svg>

                            </router-link>
                        </div>

                        <button
                            class="catalog__button"
                            :class="{
                                active__catalog__button:
                                    catalog.visibleOnDesktop,
                                maingPage: getIsThisMainPage
                            }"
                            type="button"
                            @click="toggleVisibilityDesktopCatalog"
                        >
                            <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M20.5768 12.8078H2.80769C2.36184 12.8078 2 12.4459 2 12.0001C2 11.5542 2.36184 11.1924 2.80769 11.1924H20.5768C21.0227 11.1924 21.3845 11.5542 21.3845 12.0001C21.3845 12.4459 21.0227 12.8078 20.5768 12.8078Z"
                                    fill="#313D65"
                                />
                                <path
                                    d="M20.5768 6.61538H2.80769C2.36184 6.61538 2 6.25353 2 5.80769C2 5.36184 2.36184 5 2.80769 5H20.5768C21.0227 5 21.3845 5.36184 21.3845 5.80769C21.3845 6.25353 21.0227 6.61538 20.5768 6.61538Z"
                                    fill="#313D65"
                                />
                                <path
                                    d="M20.5768 19.0001H2.80769C2.36184 19.0001 2 18.6383 2 18.1925C2 17.7466 2.36184 17.3848 2.80769 17.3848H20.5768C21.0227 17.3848 21.3845 17.7466 21.3845 18.1925C21.3845 18.6383 21.0227 19.0001 20.5768 19.0001Z"
                                    fill="#313D65"
                                />
                            </svg>

                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                class="arrow"
                            >
                                <path d="M12 21l-12-18h24z" />
                            </svg>

                            <div
                                class="arrows"
                                :class="{
                                    arrows__visible: catalog.visibleOnDesktop
                                }"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    class="down__arrow"
                                >
                                    <path d="M12 21l-12-18h24z" />
                                </svg>

                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    class="addition__arrow"
                                >
                                    <path d="M12 21l-12-18h24z" />
                                </svg>

                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    class="extra__addition__arrow"
                                >
                                    <path d="M24 0h-24v24h24v-24z" />
                                </svg>
                            </div>
                        </button>
                    </div>

                    <div
                        class="catalog_box d-flex  align-items-center catalog__box__second"
                        v-else
                    >
                        <div class="logo__box">
                            <router-link :to="{ name: 'home' }">
                                <svg width="100" height="40" viewBox="0 0 686 217" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M194.869 112.157C116.512 116.252 112.797 169.036 112.797 180.91C112.797 192.754 109.268 192.754 107.221 192.218C105.204 191.652 100.573 188.503 73.3324 165.357C46.9405 142.903 27.5394 111.248 26.3412 109.297C67.2808 160.756 107.046 180.814 107.046 180.814C109.28 88.2824 0.328613 75.2219 0.328613 75.2219C-6.88505 200.534 107.058 202.581 107.058 202.581C201.547 205.345 194.869 112.157 194.869 112.157ZM117.048 190.105C117.048 190.105 167.532 157.854 178.81 135.243C177.521 138.14 156.103 184.595 117.048 190.105Z" fill="#6C9672"/>
                                    <path d="M182.639 101.331C182.639 101.331 139.291 114.945 124.286 125.507C124.286 125.507 159.3 86.3254 163.744 68.2612C163.744 68.2612 126.495 97.718 117.054 112.169C117.054 112.169 129.566 67.7072 128.452 39.6414C128.452 39.6414 109.003 83.8266 105.107 107.726C105.107 107.726 90.9329 59.0966 83.1532 41.8693C83.1532 41.8693 80.9313 81.3277 92.6009 109.117C92.6009 109.117 66.2029 79.1058 28.6895 73.548C41.0755 36.4741 74.9521 12.4245 110.111 14.0804C137.972 15.3931 165.876 32.8071 177.635 59.9336C185.066 77.0585 183.892 93.0634 182.639 101.331Z" fill="#E5BD89"/>
                                    <path d="M297.414 135.244C297.414 135.244 317.694 131.053 317.411 111.055C317.188 95.4961 307.897 89.3543 295.427 86.0786C289.255 84.4709 282.89 83.8085 276.531 83.8085H237.103V193.85H285.732C285.732 193.85 316.598 193.314 321.572 173.57C326.575 153.856 321.036 144.408 297.414 135.244ZM252.096 91.0884H283.402C294.674 91.0884 303.808 100.223 303.808 111.465C303.808 117.101 301.538 122.207 297.823 125.886C294.138 129.571 289.038 131.841 283.396 131.841H252.09V91.0884H252.096ZM298.865 180.591C294.427 184.999 288.315 187.738 281.577 187.738H252.096V138.826H281.577C295.089 138.826 306.018 149.785 306.018 163.297C306.012 170.041 303.272 176.153 298.865 180.591Z" fill="#6C9672"/>
                                    <path d="M359.886 83.8145V161.316C359.886 177.225 372.784 190.117 388.686 190.117C404.595 190.117 417.487 177.219 417.487 161.316V83.8145H428.855V154.301C428.855 177.532 410.02 196.367 386.79 196.367C363.559 196.367 344.724 177.532 344.724 154.301V83.8145H359.886Z" fill="#6C9672"/>
                                    <path d="M469.65 83.8145V161.316C469.65 177.225 482.548 190.117 498.451 190.117C514.359 190.117 527.251 177.219 527.251 161.316V83.8145H538.62V154.301C538.62 177.532 519.785 196.367 496.554 196.367C473.323 196.367 454.488 177.532 454.488 154.301V83.8145H469.65Z" fill="#6C9672"/>
                                    <path d="M570.292 193.314L574.736 109.671L616.977 185.251H622.534L661.993 109.671L669.772 193.314H685.338L675.607 85.7715H665.606L625.033 166.91L581.131 85.7715H570.292L561.122 193.314H570.292Z" fill="#6C9672"/>
                                </svg>
                            </router-link>
                        </div>

                        <button
                            class="catalog__button catalog__button__second"
                            type="button"
                            id="dropdownMenuButton"
                            @click="switchCatalogVisible"
                        >
                            <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M20.5768 12.8078H2.80769C2.36184 12.8078 2 12.4459 2 12.0001C2 11.5542 2.36184 11.1924 2.80769 11.1924H20.5768C21.0227 11.1924 21.3845 11.5542 21.3845 12.0001C21.3845 12.4459 21.0227 12.8078 20.5768 12.8078Z"
                                    fill="#313D65"
                                />
                                <path
                                    d="M20.5768 6.61538H2.80769C2.36184 6.61538 2 6.25353 2 5.80769C2 5.36184 2.36184 5 2.80769 5H20.5768C21.0227 5 21.3845 5.36184 21.3845 5.80769C21.3845 6.25353 21.0227 6.61538 20.5768 6.61538Z"
                                    fill="#313D65"
                                />
                                <path
                                    d="M20.5768 19.0001H2.80769C2.36184 19.0001 2 18.6383 2 18.1925C2 17.7466 2.36184 17.3848 2.80769 17.3848H20.5768C21.0227 17.3848 21.3845 17.7466 21.3845 18.1925C21.3845 18.6383 21.0227 19.0001 20.5768 19.0001Z"
                                    fill="#313D65"
                                />
                            </svg>

                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                class="arrow"
                            >
                                <path d="M12 21l-12-18h24z" />
                            </svg>
                        </button>

                        <div
                            class="catalog__content__second"
                            ref="catalog__content__second"
                            :class="{ catalog__visible: isCatalogVisible }"
                        >
                            <div class="item__container">
                                <div
                                    class="item__sub__container"
                                    :class="{
                                        visibleSecondCatalog:
                                            catalog.visibleSecondCatalog,
                                        visibleThirdCatalog:
                                            catalog.visibleThirdCatalog
                                    }"
                                >
                                    <div class="item__box">
                                        <div class="item__box--heading">
                                            <span>
                                                Каталог товаров
                                            </span>
                                            <div class="icon">
                                                <button
                                                    @click="
                                                        switchCatalogVisible();
                                                        resetCatalogPosition();
                                                    "
                                                >
                                                    <svg
                                                        width="24"
                                                        height="24"
                                                        viewBox="0 0 24 24"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path
                                                            d="M3.92561 21C3.6885 21 3.45139 20.9098 3.27124 20.7283C2.90959 20.3667 2.90959 19.7803 3.27124 19.4187L19.4191 3.27123C19.7808 2.90959 20.3671 2.90959 20.7288 3.27123C21.0904 3.63288 21.0904 4.2192 20.7288 4.58107L4.58111 20.7283C4.3996 20.9087 4.16249 21 3.92561 21Z"
                                                            fill="white"
                                                        />
                                                        <path
                                                            d="M20.0746 21C19.8375 21 19.6006 20.9098 19.4202 20.7283L3.27124 4.58107C2.90959 4.2192 2.90959 3.63288 3.27124 3.27123C3.6329 2.90959 4.21923 2.90959 4.58111 3.27123L20.7288 19.4187C21.0904 19.7803 21.0904 20.3667 20.7288 20.7283C20.5473 20.9087 20.3104 21 20.0746 21Z"
                                                            fill="white"
                                                        />
                                                    </svg>
                                                </button>
                                            </div>
                                        </div>

                                        <div
                                            class="item__box--item"
                                            v-for="(main,
                                            index) in catalog.data"
                                            :key="main.id"
                                            @click="
                                                changeActiveMainCatalog(
                                                    index,
                                                    main.name,
                                                    main.id
                                                );
                                                goToCatalog(1);
                                            "
                                        >
                                            <div class="d-flex">
                                                <div class="item__box--img">
                                                    <img
                                                        :src="
                                                            'https://pos.buum.uz/uploads/catalog/' +
                                                                main.img
                                                        "
                                                        alt="Catalog icon"
                                                    />
                                                </div>

                                                <button
                                                    class="item__box--button"
                                                >
                                                    {{ main.name }}
                                                </button>
                                            </div>

                                            <div class="item__box--vector">
                                                <svg
                                                    width="8"
                                                    height="13"
                                                    viewBox="0 0 8 13"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path
                                                        d="M1.26172 11.5686L6.13128 6.69904L1.26172 1.82947"
                                                        stroke="#7A7A7A"
                                                        stroke-width="1.8"
                                                        stroke-linecap="round"
                                                        stroke-linejoin="round"
                                                    />
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div
                                    class="item__sub__container"
                                    :class="{
                                        visibleSecondCatalog:
                                            catalog.visibleSecondCatalog,
                                        visibleThirdCatalog:
                                            catalog.visibleThirdCatalog
                                    }"
                                >
                                    <div class="item__box">
                                        <div class="item__box--heading">
                                            <div
                                                class="d-flex align-items-center"
                                            >
                                                <div class="icon">
                                                    <button
                                                        @click="
                                                            backToCatalog(1)
                                                        "
                                                    >
                                                        <svg
                                                            width="24"
                                                            height="24"
                                                            viewBox="0 0 24 24"
                                                            fill="none"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                        >
                                                            <path
                                                                d="M19 11H7.83L12.71 6.12003C13.1 5.73003 13.1 5.09003 12.71 4.70003C12.32 4.31003 11.69 4.31003 11.3 4.70003L4.71 11.29C4.32 11.68 4.32 12.31 4.71 12.7L11.29 19.3C11.68 19.69 12.31 19.69 12.7 19.3C13.09 18.91 13.09 18.28 12.7 17.89L7.83 13H19C19.55 13 20 12.55 20 12C20 11.45 19.55 11 19 11Z"
                                                                fill="white"
                                                            />
                                                        </svg>
                                                    </button>
                                                </div>

                                                <span>
                                                    {{
                                                        catalog
                                                            .activeMainCatalog
                                                            .name
                                                    }}
                                                </span>
                                            </div>

                                            <div class="icon">
                                                <button
                                                    @click="
                                                        switchCatalogVisible();
                                                        resetCatalogPosition();
                                                    "
                                                >
                                                    <svg
                                                        width="24"
                                                        height="24"
                                                        viewBox="0 0 24 24"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path
                                                            d="M3.92561 21C3.6885 21 3.45139 20.9098 3.27124 20.7283C2.90959 20.3667 2.90959 19.7803 3.27124 19.4187L19.4191 3.27123C19.7808 2.90959 20.3671 2.90959 20.7288 3.27123C21.0904 3.63288 21.0904 4.2192 20.7288 4.58107L4.58111 20.7283C4.3996 20.9087 4.16249 21 3.92561 21Z"
                                                            fill="white"
                                                        />
                                                        <path
                                                            d="M20.0746 21C19.8375 21 19.6006 20.9098 19.4202 20.7283L3.27124 4.58107C2.90959 4.2192 2.90959 3.63288 3.27124 3.27123C3.6329 2.90959 4.21923 2.90959 4.58111 3.27123L20.7288 19.4187C21.0904 19.7803 21.0904 20.3667 20.7288 20.7283C20.5473 20.9087 20.3104 21 20.0746 21Z"
                                                            fill="white"
                                                        />
                                                    </svg>
                                                </button>
                                            </div>
                                        </div>

                                        <div
                                            class="item__box--item"
                                            v-for="(addition, index) in catalog
                                                .data[
                                                catalog.activeMainCatalog.index
                                            ].children"
                                            :key="addition.id"
                                        >
                                            <button
                                                class="item__box--button"
                                                @click="
                                                    changeActiveSubCatalog(
                                                        index,
                                                        addition.name,
                                                        addition.id
                                                    );
                                                    goToCatalog(2);
                                                "
                                            >
                                                {{ addition.name }}
                                            </button>
                                        </div>

                                        <div
                                            class="item__box--item"
                                            @click="
                                                unvisibleDesktopCatalogImmediately
                                            "
                                        >
                                            <button
                                                class="item__box--button"
                                                @click="
                                                    goToCategoryAndSwitchCatalog(
                                                        catalog
                                                            .activeMainCatalog
                                                            .id
                                                    )
                                                "
                                                style="font-family: Acrom-Medium, sans-serif"
                                            >
                                                Показать все
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <div
                                    class="item__sub__container"
                                    :class="{
                                        visibleSecondCatalog:
                                            catalog.visibleSecondCatalog,
                                        visibleThirdCatalog:
                                            catalog.visibleThirdCatalog
                                    }"
                                >
                                    <div class="item__box">
                                        <div class="item__box--heading">
                                            <div
                                                class="d-flex align-items-center"
                                            >
                                                <div class="icon">
                                                    <button
                                                        @click="
                                                            backToCatalog(2)
                                                        "
                                                    >
                                                        <svg
                                                            width="24"
                                                            height="24"
                                                            viewBox="0 0 24 24"
                                                            fill="none"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                        >
                                                            <path
                                                                d="M19 11H7.83L12.71 6.12003C13.1 5.73003 13.1 5.09003 12.71 4.70003C12.32 4.31003 11.69 4.31003 11.3 4.70003L4.71 11.29C4.32 11.68 4.32 12.31 4.71 12.7L11.29 19.3C11.68 19.69 12.31 19.69 12.7 19.3C13.09 18.91 13.09 18.28 12.7 17.89L7.83 13H19C19.55 13 20 12.55 20 12C20 11.45 19.55 11 19 11Z"
                                                                fill="white"
                                                            />
                                                        </svg>
                                                    </button>
                                                </div>

                                                <span>
                                                    {{
                                                        catalog.activeSubCatalog
                                                            .name
                                                    }}
                                                </span>
                                            </div>

                                            <div class="icon">
                                                <button
                                                    @click="
                                                        switchCatalogVisible();
                                                        resetCatalogPosition();
                                                    "
                                                >
                                                    <svg
                                                        width="24"
                                                        height="24"
                                                        viewBox="0 0 24 24"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path
                                                            d="M3.92561 21C3.6885 21 3.45139 20.9098 3.27124 20.7283C2.90959 20.3667 2.90959 19.7803 3.27124 19.4187L19.4191 3.27123C19.7808 2.90959 20.3671 2.90959 20.7288 3.27123C21.0904 3.63288 21.0904 4.2192 20.7288 4.58107L4.58111 20.7283C4.3996 20.9087 4.16249 21 3.92561 21Z"
                                                            fill="white"
                                                        />
                                                        <path
                                                            d="M20.0746 21C19.8375 21 19.6006 20.9098 19.4202 20.7283L3.27124 4.58107C2.90959 4.2192 2.90959 3.63288 3.27124 3.27123C3.6329 2.90959 4.21923 2.90959 4.58111 3.27123L20.7288 19.4187C21.0904 19.7803 21.0904 20.3667 20.7288 20.7283C20.5473 20.9087 20.3104 21 20.0746 21Z"
                                                            fill="white"
                                                        />
                                                    </svg>
                                                </button>
                                            </div>
                                        </div>

                                        <div
                                            class="item__box--item"
                                            v-for="extra in catalog
                                                .activeSubCatalog.extraArray"
                                            :key="extra.id"
                                            @click="
                                                unvisibleDesktopCatalogImmediately
                                            "
                                        >
                                            <button
                                                class="item__box--button"
                                                @click="
                                                    goToCategoryAndSwitchCatalog(
                                                        extra.id
                                                    )
                                                "
                                            >
                                                {{ extra.name }}
                                            </button>
                                        </div>

                                        <div
                                            class="item__box--item"
                                            @click="
                                                unvisibleDesktopCatalogImmediately
                                            "
                                        >
                                            <button
                                                class="item__box--button"
                                                @click="
                                                    goToCategoryAndSwitchCatalog(
                                                        catalog.activeSubCatalog
                                                            .id
                                                    )
                                                "
                                                style="font-family: Acrom-Medium, sans-serif"
                                            >
                                                Показать все
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="search_box">
                        <form
                            aria-autocomplete="off"
                            autocomplete="off"
                            @submit.prevent.stop="
                                blurSearchInput();
                                searchSubmitted();
                            "
                        >
                            <input
                                autocomplete="off"
                                autocapitalize="off"
                                type="text"
                                size="10"
                                placeholder="Искать товары…"
                                data-unscoped-placeholder="Искать товары…"
                                data-scoped-placeholder="Искать товары…"
                                aria-haspopup="listbox"
                                aria-autocomplete="list"
                                aria-label="Search or jump to…"
                                aria-controls="jump-to-results"
                                id="search__input__custom"
                                v-model="search"
                                @focus="toggleSearchExapmlesVisibilty"
                                @blur="toggleSearchExapmlesVisibilty"
                            />

                            <div
                                class="list__box"
                                v-if="isFocussedSearchInput"
                                :key="'search-exapmles-list'"
                            >
                                <ul
                                    v-if="!isSearchingExamples"
                                    :key="'is-searching-examples'"
                                >
                                    <li
                                        v-for="example in searchExamples"
                                        :key="example.id"
                                        @click="
                                            redirectTo('product', example.id, example.slug)
                                        "
                                    >
                                        <div class="list__container">
                                            <div class="content__box">
                                                <div class="name__box">
                                                    <p>
                                                        {{ example.name }}
                                                        {{ example.title }}
                                                    </p>
                                                </div>

                                                <div class="price__box">
                                                    <p
                                                        class="empty"
                                                        v-if="!example.price"
                                                        :key="
                                                            'if-min-price-null'
                                                        "
                                                    >
                                                        Нет в наличии!
                                                    </p>

                                                    <p v-else>
                                                        {{
                                                            updatePriceFormat(
                                                                example.price
                                                            )
                                                        }}
                                                        сум
                                                    </p>
                                                </div>
                                            </div>

                                            <div class="img__box">
                                                <img
                                                    :src="
                                                        `https://pos.buum.uz/uploads/products/medium/${example.photo}`
                                                    "
                                                    alt="Product photo"
                                                />

                                                <svg
                                                    data-v-978febb8=""
                                                    width="16"
                                                    height="26"
                                                    viewBox="0 0 8 13"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path
                                                        data-v-978febb8=""
                                                        d="M1.26172 11.5686L6.13128 6.69904L1.26172 1.82947"
                                                        stroke="#7A7A7A"
                                                        stroke-width="1.8"
                                                        stroke-linecap="round"
                                                        stroke-linejoin="round"
                                                    ></path>
                                                </svg>
                                            </div>
                                        </div>
                                    </li>

                                    <li
                                        v-if="searchExamples.length === 0"
                                        :key="'if-exapmles-not-fount'"
                                    >
                                        <div>
                                            <div class="content__box">
                                                <div class="price__box">
                                                    <p class="empty">
                                                        {{
                                                            !isSearchedOnce
                                                                ? "..."
                                                                : "Ничего не найдено"
                                                        }}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                </ul>

                                <div v-else class="loading__box">
                                    <div class="lds-ellipsis">
                                        <div></div>
                                        <div></div>
                                        <div></div>
                                        <div></div>
                                    </div>
                                </div>
                            </div>
                        </form>

                        <button @click="searchSubmitted">
                            <svg
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <g clip-path="url(#clip0)">
                                    <path
                                        d="M15.9377 14.9243L11.3215 10.3081C12.1931 9.21671 12.7167 7.83561 12.7167 6.33336C12.7167 2.81355 9.85313 -0.05 6.33333 -0.05C2.81352 -0.05 -0.05 2.81355 -0.05 6.33336C-0.05 9.85317 2.81355 12.7167 6.33336 12.7167C7.83561 12.7167 9.21671 12.1931 10.3081 11.3216L14.9243 15.9377L14.9243 15.9377C15.0741 16.0874 15.3167 16.0874 15.4664 15.9377L15.4665 15.9377L15.9377 15.4664L15.9024 15.4311L15.9377 15.4664C16.0874 15.3167 16.0874 15.074 15.9377 14.9243ZM6.33336 11.2834C3.60381 11.2834 1.38335 9.0629 1.38335 6.33336C1.38335 3.60381 3.60381 1.38335 6.33336 1.38335C9.0629 1.38335 11.2834 3.60381 11.2834 6.33336C11.2834 9.0629 9.0629 11.2834 6.33336 11.2834Z"
                                        fill="#A3A6AB"
                                        stroke="#A3A6AB"
                                        stroke-width="0.1"
                                    />
                                </g>
                                <defs>
                                    <clipPath id="clip0">
                                        <rect
                                            width="16"
                                            height="16"
                                            fill="white"
                                        />
                                    </clipPath>
                                </defs>
                            </svg>
                        </button>
                    </div>

                    <div
                        class="profile_box d-flex justify-content-center align-items-center "
                    >
                        <button @click="profileBoxClicked">
                            <svg
                                width="26"
                                height="26"
                                viewBox="0 0 26 26"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M22.2549 15.9653C21.5258 15.3247 20.6416 14.7711 19.6266 14.3201C19.1927 14.1274 18.685 14.3228 18.4923 14.7565C18.2996 15.1902 18.495 15.698 18.9287 15.8908C19.7845 16.2712 20.522 16.7306 21.1204 17.2564C21.8581 17.9046 22.2812 18.8432 22.2812 19.832V21.4219C22.2812 21.8957 21.8957 22.2812 21.4219 22.2812H4.57812C4.10429 22.2812 3.71875 21.8957 3.71875 21.4219V19.832C3.71875 18.8432 4.14189 17.9046 4.87958 17.2564C5.74785 16.4934 8.27763 14.7188 13 14.7188C16.5065 14.7188 19.3594 11.8659 19.3594 8.35938C19.3594 4.85289 16.5065 2 13 2C9.49352 2 6.64062 4.85289 6.64062 8.35938C6.64062 10.4093 7.61581 12.2355 9.12643 13.3991C6.36234 14.0067 4.64291 15.1763 3.7451 15.9653C2.63614 16.9397 2 18.3489 2 19.832V21.4219C2 22.8435 3.15646 24 4.57812 24H21.4219C22.8435 24 24 22.8435 24 21.4219V19.832C24 18.3489 23.3639 16.9397 22.2549 15.9653ZM8.35938 8.35938C8.35938 5.80055 10.4412 3.71875 13 3.71875C15.5588 3.71875 17.6406 5.80055 17.6406 8.35938C17.6406 10.9182 15.5588 13 13 13C10.4412 13 8.35938 10.9182 8.35938 8.35938Z"
                                    fill="#6C9672"
                                />
                            </svg>
                        </button>
                    </div>

                    <div
                        class="like_box d-flex justify-content-center align-items-center "
                    >
                        <router-link :to="{ name: 'favorite' }">
                            <svg
                                width="26"
                                height="26"
                                viewBox="0 0 26 26"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M13 4.89485C12.5574 4.27472 12.0572 3.74093 11.5066 3.30208L11.4755 3.34118L11.5066 3.30208C10.3813 2.40535 9.10166 1.95 7.70459 1.95C5.8367 1.95 4.11847 2.72076 2.86667 4.11964L2.86667 4.11965C1.62987 5.50191 0.95 7.3887 0.95 9.4315C0.95 11.5367 1.71206 13.4618 3.34141 15.4875C4.7972 17.2973 6.8884 19.1334 9.30463 21.255L9.30563 21.2558L9.306 21.2562L9.30984 21.2596L9.31021 21.2599C10.1349 21.984 11.0695 22.8047 12.0387 23.6779C12.3045 23.9178 12.6458 24.05 13 24.05C13.354 24.05 13.6955 23.9178 13.9611 23.6783C14.9326 22.803 15.8685 21.981 16.6947 21.2558L16.6617 21.2182L16.6947 21.2558L16.698 21.2529C19.1131 19.1323 21.2034 17.2968 22.6588 15.4873C24.2881 13.4618 25.05 11.5367 25.05 9.4315C25.05 7.38871 24.3703 5.50191 23.1335 4.11965L23.0963 4.15299L23.1335 4.11964C21.8817 2.72076 20.1633 1.95 18.2956 1.95C16.8985 1.95 15.6189 2.40535 14.4936 3.30208C13.9428 3.74093 13.4427 4.27473 13 4.89485ZM10.2881 20.0824L10.2876 20.0821L10.2837 20.0787C10.2836 20.0786 10.2835 20.0785 10.2834 20.0785C7.91442 17.9983 5.87324 16.2058 4.50167 14.5006C3.08416 12.7384 2.4557 11.176 2.4557 9.4315C2.4557 7.77515 2.99621 6.26163 3.97464 5.16812C4.93838 4.09125 6.26261 3.49853 7.70459 3.49853C8.75942 3.49853 9.72796 3.84381 10.5843 4.52602C11.3484 5.13494 11.8816 5.90566 12.1945 6.44611L12.1945 6.44612C12.365 6.74051 12.6662 6.91724 13 6.91724C13.3338 6.91724 13.635 6.74051 13.8055 6.44612C14.1186 5.90566 14.6518 5.13493 15.4157 4.52601C16.272 3.84381 17.2406 3.49853 18.2956 3.49853C19.7374 3.49853 21.0618 4.09125 22.0254 5.16811C23.0038 6.26163 23.5443 7.77515 23.5443 9.4315C23.5443 11.176 22.9158 12.7384 21.4985 14.5006C20.1275 16.2051 18.0877 17.9964 15.7202 20.0754L15.7169 20.0783C14.8969 20.7981 13.9687 21.6131 12.9981 22.4837C12.0331 21.6148 11.1064 20.8011 10.2881 20.0824Z"
                                    fill="#6C9672"
                                    stroke="#363F4D"
                                    stroke-width="0.1"
                                />
                            </svg>

                            <p v-if="getTotalFavourite > 0" :key="'like count'">
                                {{ getTotalFavourite }}
                            </p>
                        </router-link>
                    </div>

                    <div class="basket_box d-flex  align-items-center">
                        <button
                            class="d-flex  align-items-center"
                            @click="redirectTo('shopcart')"
                        >
                            <svg
                                width="22"
                                height="25"
                                viewBox="0 0 22 25"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M21.9988 15.0164V6.2905L4.80913 3.18682V2.11409C4.80913 0.948391 3.86079 0 2.69509 0H0.511719V1.43247H2.69504C3.07088 1.43247 3.37666 1.73826 3.37666 2.11409V15.3408C3.37666 16.8678 4.6189 18.11 6.14586 18.11H6.71909V19.7424C6.42644 19.6142 6.10356 19.5425 5.76411 19.5425C4.44767 19.5425 3.37666 20.6135 3.37666 21.9299C3.37666 23.2464 4.44767 24.3174 5.76411 24.3174C7 24.3174 8.01944 23.3734 8.13958 22.1687H8.15156V18.11H20.5663V19.7424C20.2737 19.6142 19.9508 19.5425 19.6113 19.5425C18.2949 19.5425 17.2239 20.6135 17.2239 21.9299C17.2239 23.2464 18.2949 24.3174 19.6113 24.3174C20.8472 24.3174 21.8667 23.3734 21.9868 22.1687H21.9988V16.6775H6.14586C5.40876 16.6775 4.80913 16.0779 4.80913 15.3408V14.7776L21.9988 15.0164ZM5.76411 22.8849C5.23753 22.8849 4.80913 22.4565 4.80913 21.9299C4.80913 21.4034 5.23753 20.975 5.76411 20.975C6.29069 20.975 6.71909 21.4034 6.71909 21.9299C6.71909 22.4565 6.29069 22.8849 5.76411 22.8849ZM19.6113 22.8849C19.0848 22.8849 18.6563 22.4565 18.6563 21.9299C18.6563 21.4034 19.0848 20.975 19.6113 20.975C20.1379 20.975 20.5663 21.4034 20.5663 21.9299C20.5663 22.4565 20.1379 22.8849 19.6113 22.8849ZM11.9715 13.4445L9.10654 13.4047V5.41837L11.9715 5.93563V13.4445ZM13.404 6.19429L16.0302 6.66849V13.5008L13.404 13.4644V6.19429ZM7.67407 13.3848L4.80913 13.345V4.64245L7.67407 5.15971V13.3848ZM20.5663 13.5638L17.4626 13.5207V6.92709L20.5663 7.48748V13.5638Z"
                                    fill="#6C9672"
                                />
                            </svg>

                            <span>
                                В корзине:
                            </span>
                            <span class="amount">
                                {{ shopcardProductCounts }}
                            </span>

                            <p>
                                {{ shopcardProductCounts }}
                            </p>
                        </button>
                    </div>

                    <div
                        class="catalog__content catalog__content__first"
                        @mouseenter="visibleDesktopCatalog"
                        @mouseleave="unvisibleDesktopCatalog"
                        :class="{ visible: catalog.visibleOnDesktop }"
                    >
                        <div class="catalog__heading">
                            <div class="box">
                                <button>
                                    <span>
                                        Каталог товаров
                                    </span>
                                </button>
                            </div>
                        </div>

                        <section class="catalog__container">
                            <main class="main__box">
                                <ul>
                                    <li
                                        class="main__box--item"
                                        v-for="(main, index) in catalog.data"
                                        :key="main.id"
                                        @mouseover="
                                            changeActiveMainCatalog(
                                                index,
                                                main.name,
                                                main.id
                                            )
                                        "
                                        :class="{
                                            active:
                                                catalog.activeMainCatalog
                                                    .index === index
                                        }"
                                        @click="
                                            unvisibleDesktopCatalogImmediately
                                        "
                                    >
                                        <router-link
                                            :to="{
                                                name: 'category',
                                                params: { id: main.id }
                                            }"
                                        >
                                            <div class="main__box--img">
                                                <img
                                                    :src="
                                                        'https://pos.buum.uz/uploads/catalog/' +
                                                            main.img
                                                    "
                                                    alt="Catalog icon"
                                                />

                                                <button>
                                                    {{ main.name }}
                                                </button>
                                            </div>

                                            <div class="main__box--vector">
                                                <svg
                                                    width="8"
                                                    height="13"
                                                    viewBox="0 0 8 13"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path
                                                        d="M1.26172 11.5686L6.13128 6.69904L1.26172 1.82947"
                                                        stroke="#7A7A7A"
                                                        stroke-width="1.8"
                                                        stroke-linecap="round"
                                                        stroke-linejoin="round"
                                                    />
                                                </svg>
                                            </div>
                                        </router-link>
                                    </li>
                                </ul>
                            </main>

                            <main class="addition__box">
                                <div class="main__catalogs__container">
                                    <div
                                        class="secondary__catalogs__container"
                                        v-for="(addition, index) in catalog
                                            .data[
                                            catalog.activeMainCatalog.index
                                        ].children"
                                        :key="addition.id"
                                    >
                                        <button
                                            type="button"
                                            @click.stop=""
                                            class="d-flex flex-column"
                                        >
                                            <div
                                                class="content d-flex  align-items-center addition__catalog__box"
                                                @click="
                                                    unvisibleDesktopCatalogImmediately
                                                "
                                            >
                                                <router-link
                                                    class="addition__catalog"
                                                    :to="{
                                                        name: 'category',
                                                        params: {
                                                            id: addition.id
                                                        }
                                                    }"
                                                >
                                                    {{ addition.name }}
                                                </router-link>
                                            </div>

                                            <div
                                                class="content d-flex justify-content-between align-items-center extra__catalog__box"
                                                v-for="extra in returnExtraCatalog(
                                                    index
                                                )"
                                                :key="extra.id"
                                                @click="
                                                    unvisibleDesktopCatalogImmediately
                                                "
                                            >
                                                <router-link
                                                    :to="{
                                                        name: 'category',
                                                        params: {
                                                            id: extra.id
                                                        }
                                                    }"
                                                >
                                                    {{ extra.name }}
                                                </router-link>
                                            </div>
                                        </button>
                                    </div>

                                    <div
                                        class="secondary__catalogs__container"
                                        v-if="
                                            catalog.activeSubCatalog.length < 1
                                        "
                                        :key="'addition__empty'"
                                    >
                                        <button
                                            type="button"
                                            @click.stop=""
                                            class="d-flex flex-column"
                                        >
                                            <div
                                                class="content d-flex  align-items-center addition__catalog__box"
                                                :key="'showCategory'"
                                                @click="
                                                    unvisibleDesktopCatalogImmediately
                                                "
                                            >
                                                <router-link
                                                    class="addition__catalog"
                                                    :to="{
                                                        name: 'category',
                                                        params: {
                                                            id:
                                                                catalog
                                                                    .activeMainCatalog
                                                                    .id
                                                        }
                                                    }"
                                                    style="font-family: Acrom-Medium, sans-serif"
                                                >
                                                    Показать все
                                                </router-link>
                                            </div>
                                        </button>
                                    </div>
                                </div>
                            </main>
                        </section>
                    </div>
                </div>
            </section>
        </div>
    </header>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";

export default {
    data() {
        return {
            catalog: {
                data: [
                    {
                        children: [
                            {
                                catalog_id: 1,
                                id: 10,
                                img: "",
                                name: "Общестроительные материалы",
                                children: [
                                    {
                                        catalog_id: 10,
                                        id: 92,
                                        img: "",
                                        name: "Цемент и инертные материалы"
                                    }
                                ]
                            }
                        ],
                        catalog_id: null,
                        id: 1,
                        img: "Стройматериалы-1638527746.png",
                        name: "Стройматериалы"
                    }
                ],

                activeSubCatalog: {
                    name: "",
                    index: 0,
                    length: 0,
                    extraArray: [],
                    id: 0
                },

                activeExtraCatalog: {
                    name: "",
                    index: 0
                },

                activeMainCatalog: {
                    name: "",
                    index: 0,
                    id: 0
                },

                visibleSecondCatalog: false,
                visibleThirdCatalog: false,

                visibleOnDesktop: false,

                timerForVisibility: 0
            },

            isCatalogVisible: false,

            window: {
                innerWidth: window.innerWidth
            },

            search: "",
            searchingExpTimeOut: {},
            searchExamples: [],
            isSearchingExamples: false,
            isSearchedOnce: false,
            isFocussedSearchInput: false,

            headerTopShow: true,

            headerObserver: {}
        };
    },

    computed: {
        ...mapGetters([
            "giveSearchText",
            "getCatalogVisible",
            "shopcardProductCounts",
            "getIsThisMainPage",
            "getTotalFavourite"
        ]),

        routeChanges() {
            return this.$route.name;
        }
    },

    watch: {
        search(newValue) {
            const searchTxt = newValue.replace(/\s+/, "");
            if (searchTxt.length > 0) {
                this.setSearchText(newValue);
                this.searchQuickExamplesForSearchExampleList();
            } else {
                this.isSearchedOnce = false;
                clearTimeout(this.searchingExpTimeOut);
            }
        },

        catalogVisible(newV) {
            this.updateCatalogVisible(newV);
        },

        getCatalogVisible(newV) {
            this.isCatalogVisible = newV;
        },

        giveSearchText(newV) {
            this.searchTxt = newV;
        },

        routeChanges(newRoute) {
            if (newRoute !== "search") {
                this.search = "";
            }
        }
    },

    methods: {
        ...mapActions(["fetchAllShopCart", "isThisMainPage", "fetchProductUniqueTypes"]),

        ...mapMutations([
            "setSearchText",
            "updateCatalogVisible",
            "resetAllShopCartData",
            "addProductToShopCard",
            "addPackageToShopCard",
            "updateShopCartId",
            "updateShopCartAmount",
            "resetUserInfo",
            "updateShopcartProductCountsManually",
            "updateFavouriteTotalManually",
            "updateCatalogSecond",
            "updateCatalogThird"
        ]),

        async getHeaderData() {
            return await axios
                .get("/sanctum/csrf-cookie")
                .then(response => {
                    return axios
                        .get("/api/product2/header")
                        .then(response => response.data)
                        .catch(error => error);
                })
                .catch(error => false);
        },

        updatePriceFormat(price) {
            const result = new Intl.NumberFormat("en-US").format(price);
            return result.replaceAll(",", " ");
        },

        updateCatalogData(catalogArray) {
            this.catalog.data = [...catalogArray];
            this.catalog.activeSubCatalog.id = 0;
            this.catalog.activeExtraCatalog.id = 0;
        },

        updateCatalogThirdOnVuex(catalogArray) {
            const catalogThird = {};
            this.pushCatalogsToObject(catalogThird, catalogArray);
            this.updateCatalogThird(catalogThird);
        },

        pushCatalogsToObject(thirdObject, catalogArray) {
            catalogArray.forEach(catalog => {
                thirdObject[catalog.id] = _.cloneDeep(catalog);
                if (catalog.children?.length > 0)
                    return this.pushCatalogsToObject(
                        thirdObject,
                        catalog.children
                    );
            });

            return thirdObject;
        },

        toggleVisibilityDesktopCatalog() {
            if (this.catalog.visibleOnDesktop) {
                clearTimeout(this.catalog.timerForVisibility);
                this.catalog.visibleOnDesktop = false;
            } else {
                clearTimeout(this.catalog.timerForVisibility);
                this.catalog.visibleOnDesktop = true;
            }
        },

        unvisibleDesktopCatalog() {
            clearTimeout(this.catalog.timerForVisibility);
            this.catalog.timerForVisibility = setTimeout(() => {
                this.catalog.visibleOnDesktop = false;
            }, 300);
        },

        visibleDesktopCatalog() {
            clearTimeout(this.catalog.timerForVisibility);
            this.catalog.visibleOnDesktop = true;
        },

        unvisibleDesktopCatalogImmediately() {
            clearTimeout(this.catalog.timerForVisibility);
            this.catalog.visibleOnDesktop = false;
        },

        backToCatalog(id) {
            if (id === 1) {
                this.catalog.visibleSecondCatalog = false;
            }

            if (id === 2) {
                this.catalog.visibleThirdCatalog = false;
            }
        },

        goToCatalog(id) {
            if (id === 1) {
                this.catalog.visibleSecondCatalog = true;
            }

            if (id === 2) {
                this.catalog.visibleThirdCatalog = true;
            }
        },

        resetCatalogPosition() {
            this.catalog.visibleSecondCatalog = this.catalog.visibleThirdCatalog = false;
        },

        switchCatalogVisible() {
            this.isCatalogVisible = !this.isCatalogVisible;
        },

        redirectTo(route, id, slug) {
            this.$router.push({
                name: route,
                params: {
                    id,
                    slug: slug || undefined
                }
            });
        },

        goToCategoryAndSwitchCatalog(categoryId) {
            this.switchCatalogVisible();
            this.redirectTo("category", categoryId);
        },

        profileBoxClicked() {
            const isLoggedin = window.Laravel.isLoggedin;
            if (isLoggedin) {
                this.redirectTo("profile");
            }
            if (!isLoggedin) {
                this.redirectTo("login");
            }
        },

        async updateShopCart(response) {
            const res = await this.fetchAllShopCart();

            if (!!res.data.status) {
                this.resetAllShopCartData();
                this.updateShopCartId(res.data.data.id);
                this.updateShopCartAmount(res.data.data.shopcart_amount);

                const products = [...res.data.data.product];
                products.forEach(elem => {
                    const product = {
                        name: elem.name,
                        id: elem.product_id,
                        photo: elem.photo,
                        weight: elem.weight,
                        packages: {}
                    };

                    this.addProductToShopCard(product);

                    elem.seller.forEach(elem => {
                        const pack = {
                            id: elem.pc_id,
                            name: elem.pc_name,
                            price: elem.pc_sum,
                            count: Number(elem.pc_count)
                        };
                        this.addPackageToShopCard({ product, pack });
                    });
                });
            }
        },

        searchSubmitted() {
            const searchTxt = this.search;
            this.redirectTo("search", searchTxt);
        },

        blurSearchInput() {
            document.getElementById("search__input__custom").blur();
        },

        setSearchTxt() {
            const length = window.location.pathname.split("/").length;
            const location = window.location.pathname.split("/")[length - 2];
            if (location === "search") this.search = this.giveSearchText;
        },

        checkIsWeHeaderAnimated() {
            if (
                this.$route.name === "product" ||
                this.$route.name === "secondproduct"
            ) {
                this.turnOnOrOffObserverApi(false);
            } else {
                this.turnOnOrOffObserverApi(true);
            }
        },

        // intersection observer for navbar animation
        turnOnOrOffObserverApi(isTurnOnn) {
            const mainHeaderBox = document.getElementById("header__main");
            const options = {
                root: null,
                threshold: 0
            };

            const callback = (entries, observer) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) this.headerTopShow = true;
                    if (!entry.isIntersecting)
                        this.headerTopShow = isTurnOnn ? false : true;
                });
            };

            this.headerObserver = new IntersectionObserver(callback, options);
            this.headerObserver.observe(mainHeaderBox);
        },

        // change active main catalog
        changeActiveMainCatalog(index, name, id) {
            this.catalog.activeMainCatalog.index = index;
            this.catalog.activeMainCatalog.name = name;
            this.catalog.activeMainCatalog.id = id;
            this.catalog.activeSubCatalog.length = this.catalog.data[
                this.catalog.activeMainCatalog.index
            ].children.length;
        },

        // change active sub catalog
        changeActiveSubCatalog(index, name, id) {
            this.catalog.activeSubCatalog.index = index;
            this.catalog.activeSubCatalog.name = name;
            this.catalog.activeSubCatalog.id = id;

            this.catalog.activeSubCatalog.extraArray = this.returnExtraCatalog(
                index
            );
        },

        returnExtraCatalog(index) {
            const array = [
                ...this.catalog.data[this.catalog.activeMainCatalog.index]
                    .children[index].children
            ];

            if (array.length > 0) {
                return array;
            } else {
                return false;
            }
        },

        clearLocalStorageAfterSomeTime() {
            const lastclear = localStorage.getItem("lastclear"),
                time_now = new Date().getTime();
            // .getTime() returns milliseconds so 1000 * 60 * 60 * 24 = 24 days
            if (time_now - lastclear > 1000 * 60 * 60 * 72) {
                this.resetAllShopCartData();
                localStorage.setItem("lastclear", time_now);
            }
        },

        toggleSearchExapmlesVisibilty() {
            // this set timeout fixes bug when vue router doesn't work because when router
            // clicked first called this function then click
            setTimeout(() => {
                this.isFocussedSearchInput = !this.isFocussedSearchInput;
            }, 300);
        },

        searchQuickExamplesForSearchExampleList() {
            clearTimeout(this.searchingExpTimeOut);
            this.searchingExpTimeOut = setTimeout(() => {
                this.searchQuickExamples();
                this.isSearchedOnce = true;
            }, 500);
        },

        async searchQuickExamples() {
            this.isSearchingExamples = true;
            const response = await this.fetchQuickExamples();
            this.setSearchExamplesData(response);
            this.isSearchingExamples = false;
        },

        async fetchQuickExamples() {
            const response = await axios
                .post("/api/product2/filter", {
                    name: this.search
                })
                .then(response => {
                    if (response.data.status) return response.data;
                    else return false;
                })
                .catch(error => error);
            return response;
        },

        setSearchExamplesData(response) {
            if (!!response) this.searchExamples = response.result.products.data;
        }
    },

    async mounted() {
        const isLoggedin = window.Laravel.isLoggedin;
        console.log("login:"+isLoggedin)

        // update is registered when local storage cleared
        this.isThisMainPage();
        await this.fetchProductUniqueTypes();

        const response = await this.getHeaderData();

        if (response.status) {
            this.updateCatalogData(response.result.catalogs);
            this.updateCatalogSecond(response.result.catalogs);
            this.updateCatalogThirdOnVuex(response.result.catalogs);
        }

        if (isLoggedin) {
            this.updateShopcartProductCountsManually(response.result.product);
            this.updateFavouriteTotalManually(response.result.favourite);
        }

        if (!isLoggedin) {
            this.resetUserInfo();
            this.clearLocalStorageAfterSomeTime();
        }

        this.setSearchTxt();
    },

    updated() {
        this.checkIsWeHeaderAnimated();
    }
};
</script>

<style lang="scss" scoped>
@import "../../../sass/_mixins.scss";

@keyframes collapseShow {
    0% {
        transform: translateX(-100%);
    }

    100% {
        transform: translateX(0);
    }
}

@keyframes headerScrollDown {
    0% {
        transform: translateY(-100%);
    }

    100% {
        transform: translateY(0);
    }
}

header {
    margin-bottom: 30px;

    // scrollbar
    /* width */
    &::-webkit-scrollbar {
        width: 8px;
    }

    /* Track */
    &::-webkit-scrollbar-track {
        box-shadow: inset 0 0 5px grey;
    }

    /* Handle */
    &::-webkit-scrollbar-thumb {
        background: $MAIN2;
    }

    /* Handle on hover */
    &::-webkit-scrollbar-thumb:hover {
        background: $MAIN3;
    }
}

.header__top {
    padding: 0 30px;
    height: 60px;
    transition: all 0.6s;
    background-color: #ffffff;

    .header_container {
        position: relative;
        height: 100%;

        .catalog_box {
            height: 100%;
            padding: 0 !important;
            margin-right: 15px;
            justify-content: center;

            .catalog__button {
                outline: none;
                border: 1px solid #e0e0e0;
                border-radius: 3px;
                background-color: #f1f1f1;
                margin-left: 20px;
                display: flex;
                align-items: center;
                padding: 6px 8px;
                position: relative;

                &:hover {
                    cursor: pointer;
                }

                .arrow {
                    margin-left: 3px;
                    padding-top: 1px;
                    width: 10px;
                    height: 10px;
                }

                .arrows {
                    display: none;

                    .down__arrow {
                        position: absolute;
                        width: 20px;
                        height: 20px;
                        bottom: -12px;
                        left: 50%;
                        transform: translateX(-50%) rotate(180deg) scaleY(1.3);
                        z-index: 1001;

                        path {
                            fill: #f2f2f3;
                            stroke: #e0e0e0;
                            stroke-width: 1px;
                        }
                    }

                    .addition__arrow {
                        position: absolute;
                        width: 14px;
                        height: 20px;
                        bottom: -21px;
                        left: 50%;
                        transform: translateX(-50%) rotate(180deg) scaleY(1.3);
                        z-index: 1002;

                        path {
                            fill: #f2f2f3;
                        }
                    }

                    .extra__addition__arrow {
                        position: absolute;
                        width: 24px;
                        height: 20px;
                        bottom: -25px;
                        left: 50%;
                        transform: translateX(-50%) scaleX(1.5);
                        z-index: 1002;

                        path {
                            fill: #f2f2f3;
                        }
                    }
                }

                .arrows__visible {
                    display: block;
                }
            }

            .maingPage {
                display: none;
            }

            .active__catalog__button {
                background-color: rgba(241, 241, 241, 0.2);
            }
        }

        .catalog__content {
            margin: 0;
            padding: 0;
            border-radius: 0;

            overflow: hidden;
            z-index: 1000;

            .catalog__heading {
                height: 55px;
                display: flex;

                .box {
                    height: 100%;
                    padding: 0;
                    min-width: 251px;
                    max-width: 251px;
                    border: 1px solid #e0e0e0;
                    border-top-right-radius: 3px;
                    border-top-left-radius: 3px;

                    button {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        position: relative;
                        width: 100%;
                        height: 100%;
                        padding-top: 4px;
                        background-color: #f2f2f3;
                        outline: none;
                        border: none;

                        svg {
                            position: absolute;
                            top: 50%;
                            left: 35px;
                            transform: translateY(-50%);
                        }

                        span {
                            font-family: Acrom, sans-serif;
                            font-size: 18px;
                            font-weight: bold;
                            /* MAIN2 */
                            color: #3E5C45;
                        }
                    }
                }
            }

            .catalog__container {
                display: flex;
                margin: 0;
                padding: 0;
                border-radius: 0;
                max-height: 100%;

                overflow: hidden;
            }

            .main__box {
                min-width: 251px;
                max-width: 251px;
                background-color: #ffffff;
                align-self: flex-start;
                border: 1px solid #e0e0e0;
                border-right: 0;
                border-bottom-left-radius: 3px;
                max-height: 80vh;
                overflow-y: scroll;

                ul {
                    list-style-type: none;
                    display: block;
                    margin: 0;
                    padding: 0;

                    .main__box--item {
                        a {
                            padding: 12px 10px;
                            display: flex;
                            align-items: center;
                            justify-content: space-between;

                            border-bottom: 1px solid #f2f2f3;

                            .main__box--img {
                                margin-right: 10px;

                                display: flex;
                                align-items: center;

                                img {
                                    height: 30px;
                                    width: 30px;
                                    margin-right: 10px;
                                }

                                button {
                                    font-family: Acrom, sans-serif;
                                    font-style: normal;
                                    font-weight: 500;
                                    font-size: 15px;
                                    line-height: 140%;
                                    /* or 21px */

                                    /* black_main */
                                    color: #363f4d;

                                    outline: none;
                                    border: none;
                                    background-color: transparent;

                                    text-align: left;
                                }
                            }

                            &:hover {
                                text-decoration: none;

                                button {
                                    cursor: pointer;
                                    color: #6C9672;
                                }

                                .main__box--vector {
                                    svg {
                                        path {
                                            stroke: #6C9672;
                                        }
                                    }
                                }
                            }
                        }
                    }

                    .active {
                        button {
                            cursor: pointer;
                            color: #6C9672 !important;
                        }

                        .main__box--vector {
                            svg {
                                path {
                                    stroke: #6C9672 !important;
                                }
                            }
                        }
                    }
                }
            }

            .addition__box {
                border: 1px solid #e0e0e0;
                background-color: #ffffff;
                overflow-y: auto;
                max-height: 80vh;
                flex-grow: 1;
                border-top-right-radius: 3px;
                border-bottom-right-radius: 3px;

                .main__catalogs__container {
                    max-width: 100vw;
                    min-width: 360px;

                    padding: 15px;
                    margin: 0;

                    column-count: 3;

                    .secondary__catalogs__container {
                        padding: 10px 0;

                        button,
                        a {
                            width: 100%;
                            font-family: Acrom, sans-serif;
                            font-style: normal;
                            font-weight: 500;
                            font-size: 15px;
                            line-height: 18px;
                            /* identical to box height */

                            /* grey_main */

                            color: #7a7a7a;

                            outline: none;
                            border: none;
                            background-color: transparent;

                            .content {
                                width: 100%;

                                .addition__catalog {
                                    font-weight: bold;
                                    margin-bottom: 3px;

                                    &:not(:first-child) {
                                        margin-top: 5px;
                                    }
                                }

                                span,
                                a {
                                    text-align: left;
                                    line-height: 1.3;
                                    margin: 3px 0;
                                }

                                svg {
                                    margin-left: 10px;
                                }
                            }
                        }

                        .addition__catalog__box {
                            margin-bottom: 2px;

                            button {
                                margin: 0 !important;
                                padding: 0 !important;
                                background-color: transparent;
                                outline: none;
                                border: none;
                                text-align: left;

                                font-size: 16px;

                                &:hover {
                                    color: #6C9672;
                                    cursor: pointer;
                                }
                            }

                            span {
                                font-size: 16px;
                            }
                        }

                        .addition__catalog__box,
                        .extra__catalog__box {
                            &:hover {
                                span,
                                a {
                                    color: #6C9672;
                                    cursor: pointer;
                                }
                            }
                        }
                    }
                }
            }
        }

        .catalog__content__first {
            position: absolute;
            top: 52px;
            right: 0;
            left: 0;
            display: none;
        }

        .visible {
            display: block;
        }

        .catalog__box__first {
            width: 250px;
        }

        .catalog__box__second {
            display: none !important;
        }

        .search_box {
            height: 100%;
            flex-basis: auto;
            flex-grow: 1;
            padding: 8px 0 7px;
            margin: 0 10px 0 0;
            position: relative;

            form {
                width: 100%;
                height: inherit;

                input {
                    width: 100%;
                    height: inherit;

                    border: 1px #e0e0e0 solid;
                    border-radius: 3px;

                    font-family: Acrom-Medium, sans-serif;
                    font-size: 15px;
                    /* identical to box height */
                    color: #7a7a7a;
                    padding: 2px 28px 0 14px;

                    &:active,
                    &:focus {
                        outline: 1px dotted #313d65;
                        outline: 5px auto -webkit-focus-ring-color;
                    }
                }

                .list__box {
                    position: absolute;
                    margin-top: -8px;
                    top: 100%;
                    left: 0;
                    right: 0;
                    background-color: #ffffff;
                    border: 1px solid #f2f2f3;
                    z-index: 1040;
                    max-height: 60vh;
                    overflow-y: scroll;

                    ul {
                        padding-inline-start: 0;
                        margin-bottom: 0;

                        display: flex;
                        flex-direction: column;
                        flex-wrap: nowrap;
                        width: 100%;

                        li {
                            list-style-type: none;
                            display: flex;
                            justify-content: space-between;
                            flex-wrap: nowrap;
                            width: 100%;
                            border-bottom: 1px solid #e0e0e0;
                            padding: 10px;

                            .list__container {
                                display: flex;
                                width: 100%;
                            }

                            .content__box {
                                flex-basis: 82%;
                                max-width: 82%;
                                width: 82%;

                                p {
                                    font-family: Acrom-Medium, sans-serif;
                                    font-size: 15px;
                                    color: #363f4d;
                                    margin-bottom: 0;
                                }

                                .name__box {
                                    p {
                                        height: 20px;
                                        word-break: break-word;
                                        overflow: hidden;
                                        margin-bottom: 5px;
                                    }
                                }

                                .price__box {
                                    .empty {
                                        color: #cc3a3a;
                                    }
                                }
                            }

                            .img__box {
                                display: flex;
                                width: 100%;
                                justify-content: flex-end;
                                align-items: center;
                                flex-basis: 17%;
                                max-width: 17%;
                                width: 17%;

                                img {
                                    height: auto;
                                    width: 64%;
                                    margin-right: 15px;
                                }

                                svg {
                                    width: 12px !important;
                                    height: auto;
                                }
                            }

                            &:hover {
                                cursor: pointer;
                                background-color: #c4d0f8;

                                .content__box {
                                    p {
                                        text-decoration: underline;
                                    }
                                }
                            }
                        }
                    }

                    .loading__box {
                        display: flex;
                        padding: 15px 10px;

                        .lds-ellipsis {
                            display: inline-block;
                            position: relative;
                            width: 80px;
                            height: 130px;
                        }

                        .lds-ellipsis div {
                            position: absolute;
                            top: 10px;
                            width: 8px;
                            height: 8px;
                            border-radius: 50%;
                            background: #7a7a7a;
                            animation-timing-function: cubic-bezier(0, 1, 1, 0);
                        }

                        .lds-ellipsis div:nth-child(1) {
                            left: 8px;
                            animation: lds-ellipsis1 0.6s infinite;
                        }

                        .lds-ellipsis div:nth-child(2) {
                            left: 8px;
                            animation: lds-ellipsis2 0.6s infinite;
                        }

                        .lds-ellipsis div:nth-child(3) {
                            left: 32px;
                            animation: lds-ellipsis2 0.6s infinite;
                        }

                        .lds-ellipsis div:nth-child(4) {
                            left: 56px;
                            animation: lds-ellipsis3 0.6s infinite;
                        }

                        @keyframes lds-ellipsis1 {
                            0% {
                                transform: scale(0);
                            }
                            100% {
                                transform: scale(1);
                            }
                        }

                        @keyframes lds-ellipsis3 {
                            0% {
                                transform: scale(1);
                            }
                            100% {
                                transform: scale(0);
                            }
                        }

                        @keyframes lds-ellipsis2 {
                            0% {
                                transform: translate(0, 0);
                            }
                            100% {
                                transform: translate(24px, 0);
                            }
                        }
                    }
                }
            }

            button {
                background-color: transparent;
                outline: none;
                border: none;

                position: absolute;
                right: 9px;
                top: -1px;
                bottom: 0;
                display: flex;
                justify-content: center;
                align-items: center;

                svg {
                    margin-top: 5px;
                    height: 18px;
                    width: 18px;
                }

                &:hover {
                    cursor: pointer;
                }
            }
        }

        .profile_box,
        .like_box,
        .basket_box {
            height: 100%;
            margin: 0 0 0 2rem;

            a,
            button {
                line-height: 1;
            }

            button {
                outline: none;
                border: none;
                background-color: transparent;
                position: relative;

                &:hover {
                    cursor: pointer;
                }
            }
        }

        .like_box {
            position: relative;

            p {
                display: flex;
                align-items: center;
                justify-content: center;
                position: absolute;
                top: 15%;
                left: 52%;
                width: 18px;
                height: 18px;
                border-radius: 10px;
                background-color: #6C9672;
                font-size: 12px;
                font-family: Acrom, sans-serif;
                color: #ffffff;
            }
        }

        .basket_box {
            svg {
                path {
                    fill: #6C9672;
                }
            }
            span {
                margin-left: 10px;
                font-family: Acrom-Bold, sans-serif;
                font-size: 16px;
                /* black_main */
                color: #363f4d;
            }

            .amount {
                margin-left: 5px;
                color: #cc3a3a;
            }

            p {
                display: none;
            }
        }
    }
}

.shadox__effect {
    box-shadow: 0 2px 1px -0.5px rgb(0 0 0 / 15%);
}

.onTop {
    padding-top: 60px;

    .header__top {
        position: fixed;
        left: 0;
        right: 0;
        top: 0;
        z-index: 1040;

        animation: headerScrollDown 0.5s ease-in-out;
        box-shadow: 0 2px 1px -0.5px rgb(0 0 0 / 15%);

        .header_container {
            .catalog_box {
                .catalog__button {
                    display: flex;
                }
            }
        }
    }
}

@media only screen and (min-width: 1440px) {
    .header__top {
        .header_container {
            max-width: 1440px;
            margin-right: auto !important;
            margin-left: auto !important;

            .catalog__content__first {
                max-width: 1440px;
            }
        }
    }
}

@media only screen and (min-width: 1200px) {
    .header__top {
        .header_container {
            .catalog__content__first {
                .catalog__heading {
                    .box {
                        flex: 0 0 25%;
                        max-width: 25%;
                    }
                }

                .catalog__container {
                    display: flex;
                    .main__box {
                        flex: 0 0 25%;
                        max-width: 25%;
                    }
                }
            }
        }
    }
}

@media only screen and (max-width: 1200px) {
    .header__top {
        .header_container {
            .catalog_box {
                flex-basis: auto;
                margin-right: 10px;
            }

            .search_box {
                flex-basis: auto;
                flex-grow: 1;
            }

            .profile_box,
            .like_box,
            .search_box,
            .basket_box {
                margin: 0 10px;
            }
        }
    }
}

@media only screen and (max-width: 992px) {
    .header__top {
        .header_container {
            .catalog_box {
                .catalog__container {
                    .extra__box {
                        display: none;
                    }

                    .addition__box {
                        .secondary__catalogs__container {
                            button {
                                &:hover {
                                    .content {
                                        z-index: 100;
                                    }

                                    .collapse {
                                        display: flex;
                                        flex-direction: column;
                                        justify-content: flex-start;
                                        animation: collapseShow 0.5s ease-in-out;
                                        margin-top: 8px;
                                        z-index: 1;

                                        a {
                                            font-family: Acrom, sans-serif;
                                            font-style: normal;
                                            font-weight: 500;
                                            font-size: 15px;
                                            line-height: 18px;
                                            color: #7a7a7a;

                                            margin: 3px 0;
                                            text-align: left;
                                        }
                                    }
                                }

                                svg {
                                    transform: rotate(90deg);
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}

@media only screen and (max-width: 768px) {
    .header__top {
        height: 50px;
        padding-right: 15px;
        padding-left: 15px;

        .header_container {
            .catalog__box__first {
                display: none !important;
            }

            .catalog__box__second {
                display: flex !important;

                .logo__box {
                    display: flex;
                    align-items: center;
                    margin-left: 10px;
                    margin-right: 1px;

                    a {
                        display: flex;

                        svg {
                            width: 32px;
                            height: 32px;
                        }
                    }
                }

                .catalog__button {
                    padding: 4px 6px;
                    margin-left: 0;

                    .arrow {
                        display: none;
                    }
                }

                .catalog__content__second {
                    display: none;
                    position: fixed;
                    top: 0;
                    left: 0;
                    bottom: 0;
                    right: 0;
                    z-index: 9990;
                    overflow-x: hidden;

                    .item__container {
                        display: flex;

                        .item__sub__container {
                            display: inline-block;

                            transition: all 0.5s;
                        }

                        .visibleSecondCatalog {
                            transform: translateX(-100vw);
                        }

                        .visibleThirdCatalog {
                            transform: translateX(-200vw);
                        }

                        .item__box {
                            display: inline-block;
                            width: 100vw;
                            height: auto;
                            display: flex;
                            flex-direction: column;
                            overflow-y: scroll;

                            .item__box--heading {
                                display: flex;
                                justify-content: space-between;
                                align-items: center;
                                height: 54px;
                                background-color: #6C9672;
                                padding: 0 15px;

                                span {
                                    margin-left: 5px;

                                    font-family: Acrom, sans-serif;
                                    font-style: normal;
                                    font-weight: 500;
                                    font-size: 16px;
                                    line-height: 1;

                                    color: #ffffff;
                                    display: block !important;
                                }

                                button {
                                    border: none;
                                    outline: none;
                                    background-color: transparent;

                                    display: flex;
                                    align-items: center;
                                    justify-content: center;

                                    &:hover {
                                        cursor: pointer;
                                    }
                                }

                                .icon {
                                    button {
                                        padding: 0 !important;
                                    }
                                }
                            }

                            .item__box--item {
                                display: flex;
                                justify-content: space-between;
                                align-items: center;
                                min-height: 54px;
                                padding: 0 15px;

                                .item__box--button {
                                    border: none;
                                    outline: none;
                                    background-color: transparent;

                                    font-family: Acrom, sans-serif;
                                    font-style: normal;
                                    font-weight: 500;
                                    font-size: 16px;
                                    line-height: 140%;
                                    /* or 22px */

                                    /* black_main */

                                    color: #363f4d;

                                    text-align: left;

                                    padding-left: 10px;

                                    &:hover {
                                        cursor: pointer;
                                        opacity: 0.7;
                                    }
                                }

                                .item__box--img {
                                    display: flex;
                                    align-items: center;

                                    img {
                                        height: 30px;
                                        width: 30px;
                                        margin-right: 5px;
                                    }
                                }

                                .item__box--vector {
                                    margin-right: 7px;
                                }
                            }
                        }
                    }
                }

                .catalog__visible {
                    display: flex;
                    background-color: #ffffff;
                }
            }

            .search_box {
                a {
                    top: 30%;
                }
            }

            .like_box {
                p {
                    top: 10%;
                }
            }
        }
    }

    .onTop {
        padding-top: 50px;
    }
}

@media only screen and (max-width: 560px) {
    header {
        margin-bottom: 15px;
    }

    .header__top {
        height: 45px;
        .header_container {
            .catalog__box__second {
                .logo__box {
                    display: flex;
                    align-items: center;
                    margin-left: 5px;

                    svg {
                        width: 27px;
                        height: 27px;
                    }
                }

                span {
                    display: none;
                }

                svg {
                    display: inline-block;
                    margin: 0 !important;
                }

                .catalog__button {
                    padding: 2px 5px;
                }
            }

            .search_box {
                a {
                    top: 26%;
                }

                button {
                    svg {
                        width: 16px;
                        height: 16px;
                    }
                }

                form {
                    .list__box {
                        ul {
                            li {
                                padding: 10px;

                                .content__box {
                                    flex-basis: 75%;
                                    max-width: 75%;
                                    width: 75%;

                                    p {
                                        font-size: 13px;
                                    }

                                    .name__box {
                                        p {
                                            height: 19px;
                                            margin-bottom: 1px;
                                        }
                                    }
                                }

                                .img__box {
                                    flex-basis: auto;
                                    max-width: 35%;
                                    width: auto;

                                    img {
                                        width: 40px;
                                        height: 40px;
                                        margin-right: 8px;
                                    }

                                    svg {
                                        width: 8px !important;
                                    }
                                }
                            }
                        }

                        .loading__box {
                            padding: 10px;
                        }
                    }
                }
            }

            .basket_box {
                svg {
                    path {
                        fill: #363f4d;
                    }
                }

                span {
                    display: none;
                }

                p {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    position: absolute;
                    top: -23%;
                    left: 52%;
                    width: 18px;
                    height: 18px;
                    border-radius: 10px;
                    background-color: #6C9672;
                    font-size: 12px;
                    font-family: Acrom, sans-serif;
                    color: #ffffff;
                }
            }

            .like_box {
                p {
                    top: 6%;
                }
            }
        }
    }

    .onTop {
        padding-top: 45px;
    }
}

@media only screen and (max-width: 440px) {
    .header__top {
        .header_container {
            .catalog__box__second {
                .logo__box {
                    margin-left: 15px;
                }

                .catalog__button__second {
                    display: none;
                }

                margin-right: 0px;
            }

            .search_box {
                min-width: 140px;

                button {
                    right: 5px;
                    top: -2px;
                }
            }

            .profile_box,
            .basket_box {
                display: none !important;
            }

            .like_box {
                p {
                    font-size: 10px;
                    width: 15px;
                    height: 16px;
                }
            }
        }
    }

    .onTop {
        .header__top {
            .header_container {
                .catalog__box__second {
                    .logo__box {
                        margin-left: 5px;
                    }

                    margin-right: 5px;
                }

                .search_box {
                    margin-left: 5px;
                }

                .profile_box,
                .basket_box {
                    display: none !important;
                }
            }
        }
    }
}
</style>
